<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-data-table
                :headers="headers"
                :loading="loading"
                :items="reportsTable"
                :rows-per-page-items="pagination.rowsPerPageItems"
                rows-per-page-text="Mostrar"
                no-data-text="Nenhum relatório encontrado."
                :total-items="pagination.totalItems"
                :pagination.sync="paginationTable"
                :style="styleTable"
            >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="{ item }">
                    <td>
                        <b>{{ item.name }}</b>
                    </td>
                    <td style="text-align: center;">
                        <v-chip
                            small
                            label
                            outline
                            :color="setColorChipType(item.type)"
                        >{{ setType(item.type) }}</v-chip>
                    </td>
                    <td>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-layout v-on="on" row>
                                    <div>{{item.params.user_name ? item.params.user_name.split(' ')[0] + ',' : ''}}</div>
                                    <span class="pl-1">{{ item.created_at | formatDateAgo}}</span>
                                </v-layout>
                            </template>
                            <span>Gerado em {{ item.created_at | formatDateTime }}</span>
                        </v-tooltip>
                    </td>
                    <td>{{ getSize(item.file) | formatSizeFile }}</td>
                    <td>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    :color="setColorStatus(item.status)"
                                    v-on="on"
                                >{{ setIconStatus(item.status) }}</v-icon>
                            </template>
                            <span>{{ setTooltipStatus(item.status) }}</span>
                        </v-tooltip>
                    </td>
                    <td>
                        <v-tooltip v-model="tooltips[item.file_id]" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    icon
                                    color="indigo"
                                    v-on="on"
                                    :disabled="item.status == 'DONE' ? dialog : true"
                                    @click="getReport(item.file_id, item.name)"
                                    :loading="loadingReport[item.file_id]"
                                >
                                    <v-icon>assignment_returned</v-icon>
                                </v-btn>
                            </template>
                            <span>Fazer download</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
        </v-flex>
        <v-dialog v-model="dialog" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Por favor espere!
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import reportingService from "@/services/reporting/reporting";

export default {
    props: {
        pagination: Object,
        reports: Object,
        doneFetching: Boolean,
        styleTable: String,
    },
    data() {
        return {
            headers: [
                { text: "Arquivo", value: "name" },
                { text: "Tipo", value: "type", width: "10%", align: "center" },
                {
                    text: "Solicitante",
                    value: "params.user_name",
                    width: "20%",
                },
                { text: "Tamanho", value: "file.size", width: "10%" },
                { text: "Status", value: "status", width: "3%" },
                { text: "Ação", value: "action", width: "3%" },
            ],
            loadingReport: [],
            filesPending: [],
            tooltips: [],
            reportsTable: [],
            interval: null,
            loading: false,
            dialog: false,
            paginationTable: this.pagination,
        };
    },
    watch: {
        paginationTable: {
            async handler() {
                if (this.doneFetching)
                    this.$emit("pagination", this.paginationTable);
            },
            deep: true,
        },
        reports: {
            async handler() {
                this.loading = true;
                this.filesPending = [];
                this.paginationTable.totalItems = this.reports.num_results;
                this.reportsTable =
                    typeof this.reports.objects === "undefined"
                        ? this.reports.reports
                        : this.reports.objects;
                if (typeof this.reportsTable === 'undefined') this.reportsTable = [];
                this.reportsTable.forEach((file) => {
                    this.loadingReport[file.file_id] = false;
                    this.tooltips[file.file_id] = false;
                    if (file.status == "PENDING") {
                        this.filesPending.push(file.id);
                    }
                });
                if (this.filesPending.length > 0) {
                    if (this.interval != null) clearInterval(this.interval);
                    this.interval = setInterval(this.checkStatus, 15000);
                }
                this.loading = false;
            },
            deep: true,
        },
    },
    methods: {
        getSize(file){
            file = file == null ? {size: 0} : file;
            return file.size ? file.size : 0;
        },
        setIconStatus(status) {
            switch (status) {
                case "DONE":
                    return "check_circle";
                case "PENDING":
                    return "report_problem"; // pendente
                case "ERROR":
                    return "cancel"; //erro
            }
        },
        setColorStatus(status) {
            switch (status) {
                case "DONE":
                    return "green";
                case "PENDING":
                    return "yellow darken-2"; // pendente
                case "ERROR":
                    return "red"; //erro
            }
        },
        setTooltipStatus(status) {
            switch (status) {
                case "DONE":
                    return "Pronto para download";
                case "PENDING":
                    return "Aguarde, estamos gerando o relatório para você"; // pendente
                case "ERROR":
                    return "Houve um erro ao gerar o relatório"; //erro
            }
        },
        setType(type) {
            switch (type) {
                case "FIRING":
                    return "Disparo";
                case "MANY_FIRING":
                    return "Múltiplos disparos";
                case "CUSTOMERS":
                    return "Clientes";
            }
        },
        setColorChipType(type) {
            switch (type) {
                case "FIRING":
                    return "orange";
                case "MANY_FIRING":
                    return "red";
                case "CUSTOMERS":
                    return "teal";
            }
        },
        getReport(id, name) {
            this.tooltips[id] = false;
            this.loadingReport[id] = true;
            this.dialog = true;
            reportingService.getFile(id).then((response) => {
                this.loadingReport.forEach((file, index) => {
                    if (index != null) {
                        this.loadingReport[index] = false;
                    }
                });
                window.location = response.url;
                this.dialog = false;
            });
        },
        checkStatus() {
            let vm = this;
            if (this.filesPending.length == 0) {
                clearInterval(this.interval);
                this.interval = null;
            } else {
                var remover = [];
                this.filesPending.forEach((id) => {
                    reportingService.getReport(id).then((resp) => {
                        if (resp.status == "DONE") {
                            for (let i = 0; i < this.reportsTable.length; i++) {
                                if (this.reportsTable[i].id == resp.id) {
                                    this.reportsTable[i].status = "DONE";
                                    
                                    this.reportsTable[i].file_id = resp.file_id;
                                    remover.push(resp.id);
                                }
                            }
                        }
                    });
                });
                if (remover.length > 0) {
                    remover.forEach((item) => {
                        this.filesPending.splice(filesPending.indexOf(item), 1);
                    });
                }
            }
        },
    },
};
</script>

<style>
</style>